export const ConfluenceMarkNeutral = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z"
      fill="url(#paint0_linear_818_561)"
    />
    <path
      d="M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z"
      fill="url(#paint1_linear_818_561)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_561"
        x1="38.7961"
        y1="41.7759"
        x2="18.2371"
        y2="29.9619"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="0.654" stopColor="#5A6880" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_561"
        x1="9.20302"
        y1="6.22383"
        x2="29.763"
        y2="18.0378"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="0.654" stopColor="#5A6880" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
